import { createContext, useCallback, useState } from "react";
import ReactDOM from 'react-dom';
import ConfirmModal from "./ConfirmModal";

export const ConfirmContext = createContext();

export default function ConfirmProvider({ children }) {
    const [state, setState] = useState({
        isOpen: false
    });

    const open = useCallback((prompt, onConfirm, subText) => {
        setState({
            isOpen: true,
            prompt,
            onConfirm,
            subText
        });
    }, []);

    const close = useCallback(() => {
        setState({
            isOpen: false
        })
    }, [])

    return (
        <ConfirmContext.Provider value={open}>
            {children}
            {state.isOpen
                ? ReactDOM.createPortal(<>
                    <ConfirmModal prompt={state.prompt} subText={state.subText} onConfirm={state.onConfirm} close={close} />
                </>, document.getElementById("confirm-modal"))
                : <></>
            }
        </ConfirmContext.Provider>
    )
}
